export default {
  inRevisionDescription: 'Aquí encontrarás el contenido que has pedido y te han pedido revisar'
}

export const en = {
  inRevisionDescription: 'Here you will find the content you have requested and have been asked to review.'
}

export const ca = {
  inRevisionDescription: 'Aquí trobaràs el contingut que has demanat i t\'han demanat revisar'
}
